const state = {
  downloadInfo: [],
}

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/batchDownload/state.js